import { Controller } from "@hotwired/stimulus"

// Collapses a long caption block to collapsedHeight px and reveals a toggle button.
// If the content is shorter than the threshold the button stays hidden.
export default class extends Controller {
  static targets = ["content", "button"]
  static values = { collapsedHeight: Number, collapsed: Boolean, moreLabel: String, lessLabel: String }

  get moreText() { return this.hasMoreLabelValue && this.moreLabelValue ? this.moreLabelValue : "続きを読む" }
  get lessText() { return this.hasLessLabelValue && this.lessLabelValue ? this.lessLabelValue : "閉じる" }

  connect() {
    if (!this.hasContentTarget) return
    if (!this.hasCollapsedValue) this.collapsedValue = true

    if (this.contentTarget.scrollHeight > this.collapsedHeightValue) {
      if (this.collapsedValue) this.clamp()
      else this.expand()
      if (this.hasButtonTarget) this.buttonTarget.classList.remove("hidden")
    } else if (this.hasButtonTarget) {
      this.buttonTarget.classList.add("hidden")
    }
  }

  toggle() {
    this.collapsedValue = !this.collapsedValue
    if (this.collapsedValue) {
      this.clamp()
      if (this.hasButtonTarget) this.buttonTarget.textContent = this.moreText
    } else {
      this.expand()
      if (this.hasButtonTarget) this.buttonTarget.textContent = this.lessText
    }
  }

  clamp() {
    this.contentTarget.style.maxHeight = `${this.collapsedHeightValue}px`
    this.contentTarget.style.overflow = "hidden"
    if (this.hasButtonTarget) this.buttonTarget.textContent = this.moreText
  }

  expand() {
    this.contentTarget.style.maxHeight = "none"
    this.contentTarget.style.overflow = "visible"
    if (this.hasButtonTarget) this.buttonTarget.textContent = this.lessText
  }
}
